<!-- text filter -->
<ng-container *ngIf="inputType === 'Text'">
  <app-custom-text-filter [control]="control" [field]="field"
    (onChangeTextFilter)="onFilter($event)"></app-custom-text-filter>
</ng-container>

<!-- select filter -->
<ng-container *ngIf="inputType === 'Select'" class="w-100 d-block" [style]="{'min-width': '100%'}">
  <app-custom-select-filter [field]="field" [control]="control" (onChangeSelectFilter)="onFilter($event)"
    [itemsSelect]="itemsSelect"></app-custom-select-filter>
</ng-container>

<!-- number range filter -->
<ng-container *ngIf="inputType === 'NumberRange'">
  <app-custom-number-range-filter [controlAlter]="controlAlter" [control]="control" [field]="field"
    (onChangeNumberRangeFilter)="onFilter($event)"></app-custom-number-range-filter>
</ng-container>

<!-- decimal range filter -->
<!-- <ng-container *ngIf="inputType === 'Decimal'">
  <div>
    <app-custom-decimal-filter [control]="control" [field]="field"
      (onChangeNumberRangeFilter)="onFilter($event)"></app-custom-decimal-filter>
  </div>
</ng-container> -->

<!-- number range filter -->
<ng-container *ngIf="inputType === 'Number'">
  <app-custom-number-filter [control]="control" [field]="field"
    (onChangeNumberFilter)="onFilter($event)"></app-custom-number-filter>
</ng-container>

<!-- date filter -->
<ng-container *ngIf="inputType === 'Date'">
  <app-custom-date-filter [control]="control" [field]="field"
    (onChangeDateFilter)="onFilter($event)"></app-custom-date-filter>
</ng-container>

<!-- date range filter -->
<ng-container *ngIf="inputType === 'DateRange'">
  <app-custom-date-range-filter [control]="control" [field]="field"
    (onChangeDateRangeFilter)="onFilter($event)"></app-custom-date-range-filter>
</ng-container>

<!-- date time range filter -->
<ng-container *ngIf="inputType === 'DateTimeRange'">
  <app-custom-date-time-range-filter [control]="control" [controlAlter]="controlAlter" [field]="field"
    (onChangeDateTimeRangeFilter)="onFilter($event)"></app-custom-date-time-range-filter>
</ng-container>

<!-- date filter -->
<!-- <ng-container *ngIf="inputType === 'Datetime'">
  <app-custom-date-filter (onChangeDateFilter)="onFilter($event)"></app-custom-date-filter>
</ng-container> -->